const PageNotFound=()=>{
    return (
        <div className="h-[100vh] text-2xl flex justify-center items-center text-richblack-100">
            <h1>Page not Found</h1>
        </div>
    )
}
export default PageNotFound